import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './i18n/en.json';
import de from './i18n/de.json';
import { createLogger } from './utils/logging';
import { isTraceLoggingEnabled } from './utils';

const logger = createLogger('I18N');

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translations: en,
            },
            de: {
                translations: de,
            },
        },
        debug: isTraceLoggingEnabled(),
        fallbackLng: 'en',
        saveMissing: true,
        missingKeyHandler: (lng, ns, key, fallbackValue) => logger.debug(`Missing translation - lng: ${lng}, ns: ${ns}, key: ${key}, fallbackValue: ${fallbackValue}`),
        keySeparator: '.',
        ns: ['translations'],
        defaultNS: 'translations',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
